import { getFullName } from '@utils/helpers';
import { Button, Table, TablePaginationConfig } from 'antd';
import { ColumnType } from 'antd/lib/table';
import { FilterValue, SorterResult } from 'antd/lib/table/interface';
import moment from 'moment';
import { formatSecondsToHumanReadable } from '@helpers';

type VideoCallRecordingsTableProps = {
  data: VideoCallRecording[];
  loading: boolean;
  onChange: (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<VideoCallRecording> | SorterResult<VideoCallRecording>[]
  ) => void;
  pagination: TablePaginationConfig;
  sorter: SorterResult<VideoCallRecording>;
  onSelect?: (videoCallRecording: VideoCallRecording) => void;
};

export const VideoCallRecordingsTable: React.FC<VideoCallRecordingsTableProps> = ({
  data,
  loading,
  onChange,
  pagination,
  sorter,
  onSelect,
}) => {
  const VideoCallRecordingsTableColumns: ColumnType<VideoCallRecording>[] = [
    {
      title: 'Course',
      dataIndex: ['videoCall', 'course', 'name'],
      key: 'videoCall.course.name',
    },
    {
      title: 'Student',
      dataIndex: ['videoCall', 'student'],
      key: 'videoCall.student',
      render: (student?: User) => (student ? getFullName(student) : '-'),
    },
    {
      title: 'Instructor',
      dataIndex: ['videoCall', 'instructor'],
      key: 'videoCall.instructor',
      render: (instructor?: User) => (instructor ? getFullName(instructor) : '-'),
    },
    {
      title: 'Call started at',
      dataIndex: ['videoCall', 'startedAt'],
      key: 'videoCall.startedAt',
      render: (startedAt: Date) => (startedAt ? moment(startedAt).format('LLL') : '-'),
    },
    {
      title: 'Duration',
      dataIndex: 'duration',
      key: 'duration',
      sorter: true,
      sortOrder: sorter.field === 'duration' ? sorter.order : null,
      render: (duration: number) => formatSecondsToHumanReadable(duration),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      render: (text: string, record: VideoCallRecording) => (
        <Button onClick={() => onSelect?.(record)}>View</Button>
      ),
    },
  ];

  return (
    <Table<VideoCallRecording>
      columns={VideoCallRecordingsTableColumns}
      dataSource={data}
      rowKey="id"
      loading={loading}
      onChange={onChange}
      pagination={pagination}
    />
  );
};
